module.exports = __webpack_public_path__ + "img/street-fighter.9b04470b.png";